export default "__VITE_ASSET__C_X3Ih_y__"